<template>
  <div class="detailConfirm">
    <div class="top">
      <div class="dis_f_l">
        <div class="left ul">
          <div class="li1 dis_f_l_b">
            <div>预定应付</div>
            <div class="dis_f_l_b">
              <span>{{ order_form.price }}</span> <span>￥</span>
            </div>
          </div>
          <div class="li2 dis_f_l_c">
            <img class="fit" src="@/images/common/time.png" alt="" />
            <div>请3分钟内完成支付，未支付订单将被系统自动取消</div>
          </div>
        </div>
        <div class="right dis_f_co_sb">
          <div class="rightTop dis_f_l_c slh_one">
            {{ detailData.portstartname }} ({{ detailData.portstartnameCn }}) --
            {{ detailData.portendname }} ({{ detailData.portendnameCn }}）
          </div>
          <div class="rightCenter dis_f_l_c slh_one">
            {{ detailData.shippingname }} <span class="xian"></span> 开航日:
            {{ detailData.etd }}
          </div>
          <div class="rightBottom dis_f_l_c slh_one">
            箱型: {{ detailData.containerTypeStr
            }}<span class="xian"></span>价格:
            {{ detailData.price ? detailData.price + "USD" : "" }}
            <span class="xian"></span> 亏舱费:
            {{ detailData.brokenPrice ? detailData.brokenPrice + "USD" : "" }}
            <span class="xian"></span> 预定数量: {{ order_form.boxNum }}
          </div>
        </div>
      </div>
      <!-- <div class="topBottom dis_f_l_c">注：亏舱费需要具体跟供应商洽谈</div> -->
    </div>
    <div class="bottom">
      <div class="dis_f_c_c">
        <div class="bottomLeft">
          <div class="erWeiMa dis_f_c_c">
            <vue-qr
              :text="code_url"
              :size="178"
              :margin="0"
              :correctLevel="3"
            ></vue-qr>
            <!-- <img class="fit payImg" :src="code_url" alt=""> -->
          </div>
          <div class="wxPayTitle dis_f_c_c">请打开手机微信，扫一扫完成支付</div>
          <!-- <div class="wxPay dis_f_c_c">
            <div class="dis_f_l_c">
              <img class="fit wxImg" src="@/images/common/wx-pay.png" alt="" />
              <div class="wxName">微信支付</div>
            </div>
          </div> -->
        </div>
        <div class="bottomRight">
          <img class="fit" src="@/images/common/wx_pay_ts.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getspacelookdetail,
  weborderpaycheck,
  orderpayfail,
} from "@/api/lookPresentCabin/lookPresentCabin";
import { mapState } from "vuex";
import vueQr from "vue-qr";
import { decode } from "@/utils/crypto.js";
export default {
  name: "",
  data() {
    return {
      id: "", //id
      detailData: {}, //数据
      timer: "",
    };
  },
  components: {
    vueQr,
  },
  watch: {},
  computed: {
    ...mapState("order", {
      orderStatus: (state) => state.orderStatus,
      code_url: (state) => state.code_url,
      orderId: (state) => state.orderId,
      order_form: (state) => state.order_form,
      order_object: (state) => state.order_object,
    }),
  },
  // 销毁事件
  destroyed() {
    clearInterval(this.timer);
  },
  mounted() {
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0, 0);
  },
  created() {
    // this.id = this.$route.query.id;
    this.id = decode(this.$route.query.id);
    // 如果改动id 或没有id 跳转首页
    if (!this.id) {
      this.$router.push("/index");
      return;
    }
    // 如果改动id 或没有id 跳转首页
    this.lookDetail();
    this.timer = setInterval(() => {
      this.pollingPay();
    }, 3000);
    console.log(this.order_object);
  },
  methods: {
    // 详情
    async lookDetail() {
      // ==========接口调用==========
      let res;
      let params = {
        id: this.id,
      };
      try {
        res = await getspacelookdetail(params);
        this.detailData = res;
      } catch (e) {
        console.error(e);
      }
    },
    // 支付失败
    async payfail() {
      // ==========接口调用==========
      let res;
      let params = {
        spaceId: this.detailData.id, //详情id
        id: this.orderId, //orderID
      };
      try {
        res = await orderpayfail(params);
        if (res.code == "1") {
          console.log("支付失败回调", res);
        } else {
          console.error(res);
        }
        setTimeout(() => {
          let object = {
            orderStatus: 1,
            code_url: "",
            orderId: "",
            order_form: {},
            object: {}, //总对象  包含code_url  orderId
          };
          this.$store.dispatch("order/orderMethods", object);
        }, 100);
      } catch (e) {
        console.error(e);
      }
    },
    // SUCCESS：支付成功
    // REFUND：转入退款
    // NOTPAY：未支付
    // CLOSED：已关闭
    // REVOKED：已撤销（付款码支付）
    // USERPAYING：用户支付中（付款码支付）
    // PAYERROR：支付失败(其他原因，如银行返回失败)
    // ACCEPT：已接收，等待扣款
    // 轮询支付
    async pollingPay() {
      // ==========接口调用==========
      let res;
      let params = {
        tradeNo: this.order_object.out_trade_no,
      };
      try {
        res = await weborderpaycheck(params);
        // console.log('respay',res)
        // 成功
        if (res.validateMap.code == "SUCCESS") {
          clearInterval(this.timer);
          this.$message({ type: "success", message: "支付成功" });
          setTimeout(() => {
            let object = {
              orderStatus: 3,
              code_url: "",
              orderId: "",
              order_form: {},
              object: {}, //总对象  包含code_url  orderId
            };
            this.$store.dispatch("order/orderMethods", object);
          }, 100);
          // 已关闭和已撤销还有支付失败
        } else if (
          res.validateMap.code == "CLOSED" ||
          res.validateMap.code == "PAYERROR" ||
          res.validateMap.code == "REVOKED"
        ) {
          clearInterval(this.timer);
          this.$message({ type: "success", message: "支付失败" });
          // 支付失败
          this.payfail();
        }
      } catch (e) {
        console.error(e);
        this.$message({ type: "error", message: e });
        clearInterval(this.timer);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.detailConfirm {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 128px;
  .top {
    width: 1040px;
    margin: 0 auto;
    height: 148px;
    border-radius: 10px;
    background: #ffffff;
    overflow: hidden;
    margin-bottom: 14px;
    .left {
      width: 406px;
      height: 148px;
      background: #ffffff;
      .li1 {
        padding-left: 20px;
        padding-top: 20px;
        div:nth-child(1) {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #373842;
          margin-right: 12px;
          margin-bottom: 6px;
        }
        div:nth-child(2) {
          font-family: PingFang SC;
          font-weight: bold;
          color: #ff7811;
          span:nth-child(1) {
            font-size: 36px;
          }
          span:nth-child(2) {
            font-size: 14px;
            margin-bottom: 6px;
          }
        }
      }
      .li2 {
        padding-left: 20px;
        padding-top: 20px;
        img {
          width: 17px;
          height: 16px;
          margin-right: 10px;
        }
        div {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #555965;
        }
      }
    }
    .right {
      width: 634px;
      height: 148px;
      background: #e7f3ff;
      padding: 26px 20px 36px;
      .xian {
        width: 1px;
        height: 10px;
        background: #d5dae6;
        border-radius: 1px;
        margin: 0 10px;
      }
      .rightTop {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #373842;
      }
      .rightCenter {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #676c77;
      }
      .rightBottom {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #676c77;
      }
    }
    .topBottom {
      height: 49px;
      border-top: 1px solid #f0f2f4;
      padding-left: 20px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #555965;
    }
  }
  .bottom {
    width: 1040px;
    height: 366px;
    background: #ffffff;
    border-radius: 10px;
    margin: 0 auto;
    padding-top: 35px;
    .bottomLeft {
      .erWeiMa {
        width: 204px;
        height: 204px;
        background: #ffffff;
        border: 1px solid #e8e9ec;
        border-radius: 4px;
        margin-bottom: 10px;
        .payImg {
          width: 178px;
          height: 178px;
        }
      }
      .wxPayTitle {
        width: 204px;
        height: 32px;
        background-color: rgba(9, 187, 7, 0.1);
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #09bb07;
      }
      .wxPay {
        .wxImg {
          width: 26px;
          height: 24px;
          margin-right: 10px;
        }
        .wxName {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #45484e;
        }
      }
    }
    .bottomRight{
      width: 208px;
      height: 256px;
      margin-left: 43px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>